var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoIcon2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 640 640",
    width: 640,
    height: 640,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M606.67 322.67C606.67 164 478.67 36 320 36C161.33 36 33.33 165.33 33.33 322.67C33.33 330.67 28 336 20 336C12 336 6.67 330.67 6.67 322.67C6.67 150.67 146.67 9.33 320 9.33C493.33 9.33 633.33 149.33 633.33 322.67C633.33 330.67 628 336 620 336C612 336 606.67 330.67 606.67 322.67Z",
    id: "a1L3avy89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.67 322.67C6.67 277.33 42.67 241.33 88 241.33C96 241.33 101.33 246.67 101.33 254.67C101.33 268.4 101.33 378.27 101.33 392C101.33 398.67 96 404 88 404C42.67 404 6.67 368 6.67 322.67ZM33.33 322.67C33.33 348 50.67 370.67 74.67 376C74.67 368.89 74.67 333.33 74.67 269.33C47.11 288 33.33 305.78 33.33 322.67Z",
    id: "c1jiIHjNEb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.67 390.67C538.67 377.07 538.67 268.27 538.67 254.67C538.67 246.67 544 241.33 552 241.33C597.33 241.33 633.33 277.33 633.33 322.67C633.33 368 597.33 404 552 404C544 404 538.67 398.67 538.67 390.67ZM565.33 376C589.33 370.67 606.67 348 606.67 322.67C606.67 297.33 589.33 276 565.33 269.33C565.33 290.67 565.33 365.33 565.33 376Z",
    id: "hBx40CANc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.33 576C364 569.33 369.33 561.33 376 560C558.67 528 562.67 392 562.67 385.33C562.67 377.33 569.33 372 576 372C584 372 589.33 378.67 589.33 385.33C589.33 386.67 586.67 549.33 380 585.33C380 586.67 380 586.67 378.67 586.67C372 586.67 366.67 582.67 365.33 576Z",
    id: "a2wWskkGAw"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.67 577.33C246.67 546.67 278.67 524 320 524C361.33 524 393.33 548 393.33 577.33C393.33 606.67 361.33 630.67 320 630.67C278.67 630.67 246.67 606.67 246.67 577.33ZM273.33 576C273.33 589.33 292 602.67 320 602.67C346.67 602.67 366.67 588 366.67 576C366.67 564 346.67 549.33 320 549.33C293.33 549.33 273.33 564 273.33 576Z",
    id: "aFdSCFDqO"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.33 334.67L362.67 334.67L362.67 353.33L317.33 446.67L290.67 446.67L333.33 356L305.33 356L305.33 370.67L281.33 370.67L281.33 334.67Z",
    id: "e2nn8S4Ip"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.33 304C185.33 304 180 298.67 180 290.67C180 282.67 185.33 277.33 193.33 277.33C218.53 277.33 420.13 277.33 445.33 277.33C453.33 277.33 458.67 282.67 458.67 290.67C460 297.33 453.33 304 446.67 304C396 304 218.67 304 193.33 304Z",
    id: "cb9ceiNUZ"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.79 135.66L365.13 135.66L365.13 154.33L319.79 247.66L293.13 247.66L335.79 157L307.79 157L307.79 171.66L283.79 171.66L283.79 135.66Z",
    id: "a1pWA2G35y"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a1L3avy89",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a1L3avy89",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c1jiIHjNEb",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c1jiIHjNEb",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hBx40CANc",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hBx40CANc",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a2wWskkGAw",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a2wWskkGAw",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#aFdSCFDqO",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#aFdSCFDqO",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e2nn8S4Ip",
    opacity: 1,
    fill: "#00af60",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e2nn8S4Ip",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cb9ceiNUZ",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cb9ceiNUZ",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a1pWA2G35y",
    opacity: 1,
    fill: "#00af60",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a1pWA2G35y",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon2);
export default __webpack_public_path__ + "static/media/info-icon-2.2804ab83789e49008682e278cea547ec.svg";
export { ForwardRef as ReactComponent };